/*@flow*/
import initFilePicker from 'lib/initFilePicker';

export default function uploadFiles(
  fn: () => any = () => {},
  accepted: string[] = ['image/*']
): Promise<{ filename: string, url: string }[]> {
  return initFilePicker({ accepted }).then((client) => {
    fn();
    return client.openDialog();
  });
}
